import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE } from '../config';

const STATUS_AR = {
  pending:'⏳ معلق', searching:'🔍 بندور على طيار', accepted:'✅ تم القبول',
  picked_up:'📦 استلم الشحنة', in_transit:'🚀 في الطريق',
  delivered:'🎉 تم التسليم', cancelled:'❌ ملغي', failed:'😔 فشل'
};
const STATUS_COLOR = {
  pending:'#f39c12', searching:'#f39c12', accepted:'#27ae60',
  picked_up:'#2980b9', in_transit:'#8e44ad',
  delivered:'#27ae60', cancelled:'#e74c3c', failed:'#e74c3c'
};

export default function MyOrders({ onTrack }) {
  const [orders, setOrders]   = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_BASE}/orders`).then(r => {
      setOrders(r.data.orders);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  if (loading) return <div style={styles.center}>⏳ جاري التحميل...</div>;

  return (
    <div style={styles.container}>
      <div style={styles.header}><h2 style={styles.title}>📋 طلباتي</h2></div>
      {orders.length === 0 ? (
        <div style={styles.empty}>
          <p style={{fontSize:'60px'}}>📭</p>
          <p>مفيش طلبات لحد دلوقتي</p>
        </div>
      ) : (
        <div style={styles.list}>
          {orders.map(order => (
            <div key={order.id} style={styles.card}>
              <div style={styles.cardTop}>
                <span style={{...styles.badge, background: STATUS_COLOR[order.status]||'#888'}}>
                  {STATUS_AR[order.status] || order.status}
                </span>
                <span style={styles.price}>{order.base_price} جنيه</span>
              </div>
              <p style={styles.addr}>📍 {order.pickup_address}</p>
              <p style={styles.addr}>🏁 {order.dropoff_address}</p>
              <div style={styles.cardBottom}>
                <span style={styles.date}>{new Date(order.requested_at).toLocaleDateString('ar-EG')}</span>
                {order.status === 'cancelled' && order.cancelled_by_name && (
                  <p style={{fontSize:'12px',color:'#e74c3c',margin:'4px 0 0'}}>
                    ملغي بواسطة: {order.cancelled_by_name}
                  </p>
                )}
                {['searching','accepted','picked_up','in_transit'].includes(order.status) && (
                  <button style={styles.trackBtn} onClick={() => onTrack(order)}>
                    🗺️ تتبع
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const styles = {
  container: { minHeight:'100vh', background:'#f5f6fa', direction:'rtl' },
  header:    { background:'linear-gradient(135deg,#10b981,#059669)', padding:'20px' },
  title:     { margin:0, color:'#fff', fontSize:'22px', fontWeight:'bold' },
  list:      { padding:'15px' },
  card:      { background:'#fff', borderRadius:'12px', padding:'15px', marginBottom:'12px', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' },
  cardTop:   { display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'10px' },
  badge:     { color:'#fff', padding:'4px 12px', borderRadius:'20px', fontSize:'13px', fontWeight:'bold' },
  price:     { fontWeight:'bold', color:'#333', fontSize:'16px' },
  addr:      { color:'#555', fontSize:'14px', margin:'4px 0' },
  cardBottom:{ display:'flex', justifyContent:'space-between', alignItems:'center', marginTop:'10px' },
  date:      { color:'#aaa', fontSize:'12px' },
  trackBtn:  { background:'linear-gradient(135deg,#10b981,#059669)', color:'#fff', border:'none', padding:'8px 16px', borderRadius:'8px', fontSize:'13px', cursor:'pointer' },
  center:    { display:'flex', justifyContent:'center', alignItems:'center', height:'100vh', fontSize:'18px' },
  empty:     { textAlign:'center', padding:'60px 20px', color:'#888' },
};
